import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"
import menuMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Autos de servicio',
            tblTitle: 'Lista de autos de {locationName}',
            tblbutton: 'Nuevo auto',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            lblName: "Nombre",
            lblDescription: "Descripcion",
            dlgUploadTitle: "Editar auto",

            headerName: 'Nombre',
            headerLocation: 'Localidad',
            headerComments: 'Descripcion',
            headerEstado: 'Estado',
            headerAction: 'Acciones',

            lblSearch: 'Buscar',
            lblEdit: 'Editar',
            lblImage: 'Galería de imágenes',
            lblAttribe: 'Atributos de auto',
            lblback: 'Atras',

        },
        en: {
            moduleTitle: 'Meeting Rooms',
            tblTitle: "{locationName}'s meeting List",
            tblbutton: 'New Meeting',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            lblName: "Name",
            lblDescription: "Comments",
            dlgUploadTitle: "Edit meeting list",

            headerName: 'Name',
            headerLocation: 'Location',
            headerComments: 'Comments',
            headerEstado: 'Status',
            headerAction: 'Actions',

            lblSearch: 'Search',
            lblEdit: 'Edit',
            lblImage: 'Image gallery',
            lblAttribe: 'Room attributes',
            lblback: 'Go back',

        }
    }
}

export default _.merge(messages, defaultMessages, menuMessages)